import React, { FC } from 'react';
import classNames from 'classnames';
import { Panel } from '@component/Panel';
import { PrimaryButton } from '@component/Button';
import { HorizontalDivider } from '@app/react/uikit/HorizontalDivider';
import { OrderPartsHelpFamilycrestContainer } from '@container/OrderPartsHelpFamilycrestContainer';
import { useBoolean } from '@app/react/hooks/useBoolean';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    SubHeading,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/feather`;

interface FeatherInnerProps {
    className?: string;
    onFamilyCrestList: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
}

export const FeatherInner: FC<FeatherInnerProps> = ({
    className,
    onFamilyCrestList,
}) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            羽根の選び方
        </Title>

        <SubTitle>羽根の種類</SubTitle>
        <SubHeading>手羽根</SubHeading>
        <Image src={`${IMG_PATH}/tehane.png`} />

        <SubHeading>尾羽根</SubHeading>
        <Image src={`${IMG_PATH}/ohane.png`} />

        <SubTitle>家紋印刷について</SubTitle>
        <Image src={`${IMG_PATH}/about-print-for-familycrest.png`} />
        <SubHeading>家紋印刷とは</SubHeading>
        <Paragraph>
            羽根の選択ボタンの写真の右下に「家紋印刷可」と表示しているものは、
            羽根に家紋を印刷することができます。
        </Paragraph>

        <HorizontalDivider className="order-parts-help-divider" />

        <PrimaryButton dark onClick={onFamilyCrestList}>
            印刷できる家紋の一覧へ＞
        </PrimaryButton>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpFeather: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => {
    const [isFC, showFC, hideFC] = useBoolean(false);

    return (
        <Panel isOpen={isOpen} onRequestClose={handleClose}>
            <div
                className="order-parts-help-panel-close"
                onClick={handleClose}
                onKeyPress={handleKeyPress(handleClose)}
                role="button"
                tabIndex="0"
            >
                <i className="icon-close" />
            </div>
            <div
                className={classNames('order-parts-help-panel', {
                    'familycrest-list-panel': isFC,
                })}
            >
                <div className={classNames('scrollable', { hidden: isFC })}>
                    <FeatherInner onFamilyCrestList={showFC} />
                </div>
                <div className={classNames('scrollable', { hidden: !isFC })}>
                    <OrderPartsHelpFamilycrestContainer goBack={hideFC} />
                </div>
            </div>
        </Panel>
    );
};
